import { useSearchParams } from '@ksyos/router';
import { useMemo } from 'react';

export function useNavigateInTabBar() {
    const [searchParams, setSearchParams] = useSearchParams();
    const selectedTab = useMemo(getSelectedTab, [searchParams.toString()]);

    function getSelectedTab(): string | null {
        return searchParams.get('tab');
    }

    function setSelectedTab(tabKey: string): void {
        setSearchParams({ tab: tabKey });
    }

    return { selectedTab, setSelectedTab };
}
